export const myMixin = {
	methods: {
		//判断窗口宽度自适应布局
		isMoBile() {
			var windowWidth = window.innerWidth;
			return windowWidth<=999 ? true : false;
			// let userAgentInfo = navigator.userAgent;
			// let Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod'];
			// let getArr = Agents.filter(i => userAgentInfo.includes(i));
			// return getArr.length ? true : false;
		}
	}
};